import { useTranslation } from 'react-i18next';

export const SaveAndCloseButton = () => {
  const { t } = useTranslation('tileForm');
  return (
    <>
      <i className="fa-light fa-lg fa-floppy-disk"></i>
      {t('tileActionMenu.saveAndCloseTile')}
    </>
  );
};

export const CloseButton = () => {
  const { t } = useTranslation('tileForm');
  return (
    <>
      <i className="fa-solid fa-x"></i>
      {t('tileActionMenu.closeTile')}
    </>
  );
};
